export default "__VITE_ASSET__BYehdZD5__"